// extracted by mini-css-extract-plugin
export default {"nav":"Menu_nav__m07Oa","menu":"Menu_menu__F-zP1"};